var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_2974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0102539 0.125H67.9738V68.0885H0.0102539V0.125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_2974)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_145_2974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 69
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0832 0.125C15.2655 0.125 0.0102539 15.3802 0.0102539 34.2031C0.0102539 53.0208 15.2655 68.276 34.0832 68.276C52.9061 68.276 68.1613 53.0208 68.1613 34.2031C68.1613 15.3802 52.9061 0.125 34.0832 0.125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_145_2974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0832 0.125C15.2655 0.125 0.0102539 15.3802 0.0102539 34.2031C0.0102539 53.0208 15.2655 68.276 34.0832 68.276C52.9061 68.276 68.1613 53.0208 68.1613 34.2031C68.1613 15.3802 52.9061 0.125 34.0832 0.125Z",
    stroke: "black",
    strokeWidth: 3.99805
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_145_2974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 20,
    width: 15,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3335 20.4009H46.0002V35.3332H31.3335V20.4009Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_145_2974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2347 34.1665C42.9378 34.1665 45.9535 31.078 45.9535 27.2811C45.9535 23.4894 42.9378 20.4009 39.2347 20.4009C35.5264 20.4009 32.5107 23.4894 32.5107 27.2811C32.5107 31.078 35.5264 34.1665 39.2347 34.1665ZM33.6305 27.2811C33.6305 24.1196 36.141 21.5467 39.2347 21.5467C42.3232 21.5467 44.8337 24.1196 44.8337 27.2811C44.8337 30.4478 42.3232 33.0207 39.2347 33.0207C36.141 33.0207 33.6305 30.4478 33.6305 27.2811Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5887 30.4325C37.8804 30.7241 38.2658 30.9272 38.6929 31.021L38.6877 31.6252C38.6877 31.9325 38.9272 32.1877 39.2293 32.1877H39.2345C39.5314 32.1877 39.7762 31.9377 39.7762 31.6356L39.7814 31.0158C40.2033 30.9272 40.5887 30.7189 40.8804 30.4325C41.2137 30.0939 41.396 29.6616 41.396 29.2189V28.9689C41.396 28.3752 41.0731 27.8179 40.5262 27.4689L38.5887 26.2397C38.3595 26.0991 38.2293 25.896 38.2293 25.6877V25.3022C38.2293 25.1147 38.3283 24.9377 38.5158 24.797C38.7137 24.646 38.9845 24.5627 39.271 24.5627C39.5575 24.5627 39.8231 24.646 40.0262 24.797C40.2085 24.9377 40.3127 25.1147 40.3127 25.3022V25.7345C40.3127 26.0418 40.5522 26.2918 40.8543 26.2918C41.1564 26.2918 41.396 26.0418 41.396 25.7345V25.3022C41.396 24.4533 40.7397 23.7241 39.8127 23.5106V22.9377C39.8127 22.6304 39.5679 22.3804 39.271 22.3804C38.9689 22.3804 38.7241 22.6304 38.7241 22.9377V23.5106C37.797 23.7241 37.1408 24.4533 37.1408 25.3022V25.6877C37.1408 26.2814 37.4689 26.8439 38.0158 27.1877L39.9533 28.4168C40.1825 28.5627 40.3127 28.7606 40.3127 28.9689V29.2189C40.3127 29.4012 40.2085 29.5835 40.0262 29.7241C39.8231 29.8752 39.5575 29.9585 39.271 29.9585H39.1981C38.9064 29.9585 38.6408 29.8752 38.4377 29.7241C38.2554 29.5835 38.1564 29.4012 38.1564 29.2189V28.9793C38.1564 28.672 37.9116 28.422 37.6095 28.422C37.3127 28.422 37.0679 28.672 37.0679 28.9793V29.2189C37.0679 29.6668 37.2554 30.0991 37.5887 30.4325Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_145_2974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 34,
    width: 35,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3804 34H51.3335V48.3906H17.3804V34Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_145_2974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.568 35.8179C49.8128 34.9533 48.5993 34.87 47.7503 35.6147L42.7555 39.7502C42.7607 39.6981 42.7607 39.6512 42.7607 39.5991C42.7399 38.3647 41.792 37.3647 40.6514 37.3647H35.1097C34.792 37.3647 34.4899 37.172 34.3024 36.8595C34.266 36.7866 34.2087 36.7345 34.1462 36.6825C31.8805 34.8491 28.8285 34.6095 26.2191 35.797L25.2503 36.2397H23.3128V35.3335C23.3128 35.0054 23.0576 34.7397 22.7399 34.7397H17.9587C17.641 34.7397 17.3857 35.0054 17.3857 35.3335V46.2241C17.3857 46.5522 17.641 46.8179 17.9587 46.8179H22.7399C23.0576 46.8179 23.3128 46.5522 23.3128 46.2241V45.2918H25.2868L32.1097 47.5106C33.6566 48.0939 34.9535 48.3908 36.2503 48.3908C37.292 48.3908 38.3337 48.2033 39.5003 47.8231C39.6097 47.7918 39.7139 47.7554 39.8232 47.7137C40.0628 47.6252 40.292 47.5106 40.516 47.3856C40.6982 47.2814 40.8701 47.1616 41.0316 47.0262L50.568 39.0575C50.5993 39.0314 50.6253 39.0054 50.6514 38.9689C51.3597 38.0627 51.3232 36.6772 50.568 35.8179ZM22.1618 45.6356H18.5368V35.922H22.1618V45.6356ZM49.7868 38.1877L40.8962 45.62C40.1149 46.2658 39.2087 46.7293 38.2295 46.9637C36.2972 47.4272 34.7035 47.2397 32.4951 46.4012C32.4899 46.396 32.4795 46.396 32.4691 46.3908L25.5472 44.1408C25.4899 44.1252 25.4326 44.1147 25.3753 44.1147H23.3128V37.4168H25.3753C25.4535 37.4168 25.5368 37.396 25.6097 37.3647L26.6826 36.8752C28.8857 35.8752 31.3805 36.1356 33.3857 37.5731C33.7868 38.1825 34.4222 38.5418 35.1097 38.5418H40.6514C41.1722 38.5418 41.5993 39.0262 41.6097 39.62C41.6149 39.9481 41.5003 40.2554 41.292 40.4741C41.1878 40.5783 41.0732 40.6564 40.943 40.6981C40.7816 40.7241 40.6149 40.7397 40.4482 40.7397H34.2816C33.9639 40.7397 33.7035 40.995 33.6982 41.3179C33.693 41.646 33.9535 41.9168 34.2764 41.9168H40.7035C40.8753 41.9168 41.042 41.8908 41.2087 41.8491C41.9274 41.7137 42.6045 41.396 43.1982 40.9012L48.4795 36.5262C48.4847 36.521 48.4899 36.521 48.4951 36.5158C48.8649 36.1877 49.3805 36.2241 49.7139 36.6043C50.0837 37.0262 50.1149 37.7241 49.7868 38.1877Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c90a83fa96ad74eba9ca031f7f07e9de.svg";
export { ForwardRef as ReactComponent };